import { Button, Typography } from "@mui/material";
import { MdError } from "@teamworksdev/icons";

interface RemoteAppContainerErrorProps {
  refresh: () => void;
  failureHeader: string;
  failureDescription: string;
}

// Using the same error component as Hub
// https://gitlab.com/teamworksdev/teamworks/-/blob/master/ui/web/src/components/components.web/RemoteAppContainerError.tsx
export const RemoteAppContainerError = ({ refresh, failureHeader, failureDescription }: RemoteAppContainerErrorProps) => (
  <div className="flex flex-col items-center justify-center text-center py-20">
    <div className="flex h-10 w-10 items-center justify-center mb-4 rounded-full text-center text-white bg-error-700">
      <MdError size={20} className="text-white" />
    </div>
    <Typography variant="h2" className="text-base font-semibold mb-1 text-error-700">
      {failureHeader}
    </Typography>
    <p className="mb-6 max-w-96 text-sm w-full opacity-60">{failureDescription}</p>
    <Button onClick={refresh}>{"Retry"}</Button>
  </div>
);

